import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { Header as CarbonHeader } from 'carbon-components-react';

function Header({
  ariaLabel,
  children,
  className: customClassName,
  key,
  ...rest
}) {
  const className = cx('om-header', {
    [customClassName]: !!customClassName
  });
  return /*#__PURE__*/React.createElement(CarbonHeader, _extends({}, rest, {
    "aria-label": ariaLabel,
    className: className,
    key: key
  }), children);
}

Header.defaultProps = {
  ariaLabel: 'Red Hat Marketplace header',
  key: 'global-nav'
};
export default Header;